const mergeClasses = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export const IconButton = ({
  href,
  icon: Icon,
  disabled = false,
  className,
  onClick,
}) => {
  const content = (
    <div className="w-10 h-10 rounded-full bg-gray-50 hover:bg-gray-100 flex items-center justify-center">
      <Icon className="w-6 h-6 text-gray-500 hover:text-gray-700" />
    </div>
  );

  if (href) {
    return <a href={href}>{content}</a>;
  }

  return (
    <button onClick={onClick} type="button" disabled={disabled}>
      {content}
    </button>
  );
};
